import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DecimalPipe } from '@angular/common';

class CountDirective {
    constructor(element, decimalPipe) {
        this.element = element;
        this.decimalPipe = decimalPipe;
        this.from = 0;
        this.countStart = false;
        this.decimals = 0;
        this.started = false;
        this.framerate = 66;
        this.time = 1500;
        this.steps = this.time / this.framerate;
    }
    ngAfterViewInit() {
        this.reset();
    }
    ngOnChanges(changes) {
        changes &&
            changes['countStart'] &&
            changes['countStart'].currentValue === true
            ? this.start()
            : this.reset();
    }
    reset() {
        this.element.nativeElement.innerHTML = 0;
    }
    start() {
        const valToAnimate = this.fstrCount - this.from;
        for (let i = 0; i <= this.steps; i++) {
            const delay = i * this.framerate;
            const factor = delay / this.time;
            // tslint:disable-next-line:max-line-length
            const formatedNumber = this.decimalPipe.transform(parseFloat((this.from + factor * valToAnimate)).toFixed(this.decimals));
            setTimeout(() => (this.element.nativeElement.innerHTML = formatedNumber), delay);
        }
        setTimeout(() => (this.element.nativeElement.innerHTML = this.decimalPipe.transform(parseFloat(this.fstrCount))), this.time);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: CountDirective, deps: [{ token: i0.ElementRef }, { token: i1.DecimalPipe }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.2", type: CountDirective, selector: "[fstrCount]", inputs: { fstrCount: "fstrCount", from: "from", countStart: "countStart", decimals: "decimals" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: CountDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fstrCount]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.DecimalPipe }]; }, propDecorators: { fstrCount: [{
                type: Input
            }], from: [{
                type: Input
            }], countStart: [{
                type: Input
            }], decimals: [{
                type: Input
            }] } });

class CountToModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: CountToModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.2", ngImport: i0, type: CountToModule, declarations: [CountDirective], imports: [CommonModule], exports: [CountDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: CountToModule, providers: [DecimalPipe], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: CountToModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CountDirective],
                    exports: [CountDirective],
                    imports: [CommonModule],
                    providers: [DecimalPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CountDirective, CountToModule };
